import React from 'react';
import Typography from '@mui/material/Typography';

interface InfoRowProps {
  label: string;
  value: string;
}

const InfoRow: React.FC<InfoRowProps> = ({ label, value }) => {
  return (
    <Typography variant="body1">
      <Typography component="span" fontWeight="bold">
        {label}
      </Typography>{' '}
      {value}
    </Typography>
  );
};

export default InfoRow;
